import { usefulLinksData } from '../data'

export default {
    name: 'usefulLinks',
    title: 'Useful Links Page',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string',
            validation: (Rule) => Rule.required(),
            initialValue: usefulLinksData.title
        },
        {
            name: 'description',
            title: 'Description',
            type: 'text',
            validation: (Rule) => Rule.required(),
            initialValue: usefulLinksData.description
        },
        {
            name: 'links',
            title: 'Links',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'title',
                            title: 'Title',
                            type: 'string'
                        },
                        {
                            name: 'url',
                            title: 'URL',
                            type: 'url'
                        },
                        {
                            name: 'description',
                            title: 'Description',
                            type: 'text'
                        }
                    ]
                }
            ],
            validation: (Rule) => Rule.required().min(1),
            initialValue: usefulLinksData.links
        },
        {
            name: 'note',
            description: 'Note displayed at the bottom of the page',
            title: 'Note',
            type: 'text',
            validation: (Rule) => Rule.required(),
            initialValue: usefulLinksData.note
        }
    ],
    preview: {
        select: {
            title: 'title',
            description: 'description'
        },
        prepare({ title, description }) {
            return {
                title: 'Useful Links Page',
                subtitle: description || 'Useful Links Page'
            }
        }
    }
} 